import React from "react";
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup, Stack, TextField } from "@mui/material";
import Cookies from 'universal-cookie';
import LoadingButton from "@mui/lab/LoadingButton";
import _default from "../themes/default";
import getOrdine from "../services/getOrdine";
import DatePickerIta from "./DatePickerMUI";
import Loading from "react-loading";
import getProdotti from "../services/getProdotti";
import getGiacenze from "../services/getGiacenze";
import createDDT from "../services/createDDT";
import addReminder from "../services/addReminder";
import addDdt from "../services/addDdt";
import getCliente from "../services/getCliente";

const cookies = new Cookies();
var token = cookies.get('token', { path: '/' });
var username = cookies.get('username', { path: '/' });

const style = {
    zIndex: 999,
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 800,
    maxHeight: 600,
    bgcolor: 'white',
    borderRadius: 2,
    border: '0',
    boxShadow: 24,
    p: 4,
    overflowY: 'scroll',
};

export default class MyModalDdt extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: true,
            prodotti: [],
            vettore: '',
            trasporto: '',
            destinazione: '',
            causale: '',
            annotazioni: '',
            data_ritiro: '',
            link_ddt: '',
            lista_pronta: '',
            ddt: '',
        }
    }


    async componentDidMount() {
        {
            this.setState({ isLoading: true });
            token = cookies.get('token', { path: '/' });
            username = cookies.get('username', { path: '/' });
            let prodottiList = await getProdotti(username, token)

            let giacenze = await getGiacenze(username, token);
            let ordine = await getOrdine(username, token, this.props.modal.id);

            let prodotti = [];

            prodotti = [...JSON.parse(ordine.prodotti)];

            prodotti = prodotti.map((prodotto, i) => {
                let giacenza = giacenze.find(g => g.id_prodotto === prodotto.id_prodotto);
                return { ...prodotto, giacenza: giacenza ? giacenza.giacenza : 0 }
            })

            this.setState({
                ragioneSociale: ordine.ragione_sociale,
                data_pronto: ordine.data_pronto,
                data_consegna: ordine.data_consegna,
                prodotti,
                conferma_magazzino: ordine.conferma_magazzino,
                conferma_cliente_data: ordine.conferma_cliente_data,
                crea_ddt: ordine.crea_ddt,
                ddt_pdf: ordine.ddt_pdf,
                lista_pronta: ordine.lista_pronta,
                link_ddt: ordine.link_ddt ? JSON.parse(ordine.link_ddt) : '',
                causale: ordine.causale == null ? '' : ordine.causale,
                trasporto: ordine.trasporto == null ? '' : ordine.trasporto,
                vettore: ordine.vettore == null ? '' : ordine.vettore,
                data_ritiro: '',
                destinazione: ordine.destinazione == null ? '' : ordine.destinazione,
                annotazioni: ordine.annotazioni,
                prodottiList,
                isLoading: false,
                linkPdf: ordine.link_pdf,
                lista_carico: ordine.lista_carico,
                ddt: this.props.modal.ddt,
            })
        }
    }

    DDT() {

        let ddt = {
            causale: this.state.causale,
            destinazione: this.state.destinazione,
            trasporto: this.state.trasporto,
            vettore: this.state.vettore,
            annotazioni: this.state.annotazioni,
            data_ritiro: this.state.data_ritiro,
            id: this.props.modal.id,
        };

        if (!ddt.causale) return alert('Inserire causale');
        if (!ddt.destinazione) return alert('Inserire destinazione');
        if (!ddt.trasporto) return alert('Inserire trasporto');
        if (!ddt.vettore) return alert('Inserire vettore');
        if (!ddt.data_ritiro) return alert('Inserire data ritiro');

        createDDT(username, token, ddt).then(async (res) => {
            if (res.result === 'ok') {
                let ordine = await getOrdine(username, token, this.props.modal.id);
                let cliente = await getCliente(username, token, ordine.id_cliente);
                addDdt(username, token, {
                    cliente: this.state.ragioneSociale,
                    rif: ordine.rif,
                    destinazione: ddt.destinazione,
                    citta: cliente.citta,
                    indirizzo: cliente.indirizzo,
                    causale: ddt.causale,
                    trasporto: ddt.trasporto,
                    vettore: ddt.vettore,
                    annotazioni: ddt.annotazioni,
                    data_ritiro: ddt.data_ritiro,
                    p_iva: cliente.p_iva,
                    prodotti: JSON.stringify(this.props.modal.ddt.prodotti),
                    ordine: this.props.modal.id,
                    index: this.props.modal.index,
                    exist: this.state.link_ddt[this.props.modal.index].url ? 1 : 0,
                }).then(res => {
                    if (res.result === 'ok') {
                        this.props.onReload();
                        this.props.onClose();
                        window.open(res.link, '_blank');
                    }
                })
            }
        })
        getOrdine(username, token, this.props.modal.id).then((ordine) => {
            //addReminder(username, token, 'DTT creato ' + ordine.rif, 'magazzino', 'ordine', ordine.id)
        })
        
    }

    close() {
        this.props.onClose();
    }

    render() {
        if (this.state.isLoading) return <Loading />;
        return (
            <Modal
                open={this.props.modal.show}
                onClose={() => this.close()}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Stack direction={"column"} spacing={2} sx={{ flex: 1 }}>
                        <Typography id="modal-modal-title" variant="h6" component="h2">
                            Crea DDT
                        </Typography>
                        <Stack direction={"row"} spacing={2} sx={{ flex: 1 }} >
                            <TextField fullWidth value={this.state.causale} label="Causale Trasporto" variant="outlined" onChange={(e) => this.setState({ causale: e.target.value })} InputLabelProps={{ shrink: this.state.causale }} error={this.state.causale.trim().length === 0} />
                        </Stack>

                        <Stack direction={"row"} spacing={2} sx={{ flex: 1 }} >
                            <TextField fullWidth value={this.state.destinazione} label="Luogo destinazione" variant="outlined" onChange={(e) => this.setState({ destinazione: e.target.value })} InputLabelProps={{ shrink: this.state.destinazione }}
                                error={this.state.destinazione.trim().length === 0} />
                        </Stack>

                        <Stack direction={"row"} spacing={2} sx={{ flex: 1 }} >
                            <FormControl>
                                <FormLabel id="demo-row-radio-buttons-group-label">Trasporto a mezzo:</FormLabel>
                                <RadioGroup
                                    row
                                    aria-labelledby="demo-row-radio-buttons-group-label"
                                    name="row-radio-buttons-group"
                                    onChange={(e) => this.setState({ trasporto: e.target.value })}
                                    value={this.state.trasporto}
                                >
                                    <FormControlLabel value="mittente" control={<Radio />} label="Mittente" />
                                    <FormControlLabel value="vettore" control={<Radio />} label="Vettore" />
                                    <FormControlLabel value="destinatario" control={<Radio />} label="Destinatario" />
                                </RadioGroup>
                            </FormControl>
                        </Stack>
                        <Stack direction={"row"} spacing={2} sx={{ flex: 1 }} >
                            <TextField fullWidth value={this.state.vettore} label="Vettore" variant="outlined" onChange={(e) => this.setState({ vettore: e.target.value })} InputLabelProps={{ shrink: this.state.vettore }}
                                error={this.state.vettore.trim().length === 0} />
                        </Stack>

                        <Stack direction={"row"} spacing={2} sx={{ flex: 1 }} >
                            <DatePickerIta
                                redBorder={this.state.data_ritiro.trim().length === 0}
                                grow
                                label="Data ritiro"
                                startValue={this.state.data_ritiro}
                                onValueChange={(date) => {
                                    this.setState({ data_ritiro: date });
                                }}
                            />
                        </Stack>

                        <Stack direction={"row"} spacing={2} sx={{ flex: 1 }} >
                            <TextField multiline rows={4} fullWidth value={this.state.annotazioni} label="Annotazioni" variant="outlined" onChange={(e) => this.setState({ annotazioni: e.target.value })} InputLabelProps={{ shrink: this.state.annotazioni }} />
                        </Stack>
                        <Stack direction={"row"} spacing={2} sx={{ flex: 1 }} >
                            {
                                (this.props.modal.partial || (this.state.crea_ddt === '1' && this.state.conferma_cliente_data !== null && !this.props.admin)) && (
                                    <LoadingButton fullWidth sx={{ flex: 1, minHeight: 50 }} style={{ backgroundColor: _default.palette.info.main }} variant='contained' loading={this.state.isLoading} onClick={() => this.DDT()}>
                                        {this.state.link_ddt[this.props.modal.index].url ? 'Sovrascrivi DDT' : 'Crea DDT'}
                                    </LoadingButton>
                                )
                            }

                            {
                                ((this.state.link_ddt && this.state.link_ddt.length > 0 && this.state.link_ddt[this.props.modal.index].url !== ''))&& (
                                    <LoadingButton fullWidth sx={{ flex: 1, minHeight: 50 }} style={{ backgroundColor: _default.palette.secondary.main }} variant='contained' loading={this.state.isLoading} onClick={() => window.open(this.state.link_ddt[this.props.modal.index].url, '_blank')}>
                                        Visualizza DDT
                                    </LoadingButton>
                                )
                            }
                        </Stack>
                    </Stack>
                </Box>
            </Modal>
        )
    }
}